import * as React from 'react';
import { observer } from 'mobx-react';
import ParticipantsStore from '../../../../../ParticipantsStore';
import { T } from '../../../../../Translations';
import { UsersIcon } from '@heroicons/react/20/solid';
import { findLink } from '../../../../../LinkyLinky';
import { emptyFragment } from '../../../../../EmptyFragment';
import ModalStore from '../../../../Modal/Store';
import ModalReactions from '../../../../Modal/ModalReactions';
import UserGroupMembershipsForm from './UserGroupMembershipsForm';

interface Props {
  store: ParticipantsStore;
}

class OpenModalButton extends React.Component<Props> {
  modalStore: ModalStore = new ModalStore();

  openModal = () => {
    this.modalStore.open();
  };

  render() {
    const { store } = this.props;
    return findLink('new-user-group-memberships', store.links)
      .map((_link) => (
        <>
          <button
            className="flex rounded-md border-[1px] items-center border-solid border-teal-600 px-5 py-2 text-teal-600"
            onClick={this.openModal}
          >
            <span className="mr-2">
              <UsersIcon height={'30px'} />
            </span>
            <T kind="Add Participants to Group" />
          </button>
          <UserGroupMembershipsForm modalStore={this.modalStore} store={store} />
          <ModalReactions store={this.modalStore} />
        </>
      ))
      .getOrElse(emptyFragment);
  }
}

export default observer(OpenModalButton);
